'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { useGeoStats } from '@/hooks/swr/useGeoStats';
import { Dataset } from '@/lib/types/Dataset';
import { GeoStats } from '@/lib/types/GeoStats';
import { Table } from '@/lib/types/Table';
import { TableMapSkeleton } from './Skeleton';
export interface TableMapProps {
  dataset: Dataset;
  table: Table;
}
export interface MapProps {
  geoStats: GeoStats | null;
}
export const classes = {
  wrapper: 'relative grid max-w-full max-h-full w-full h-[400px]'
};

// webgl map
const MapGL = dynamic(() => import('./MapGL').then(r => r.MapGL), {
  ssr: false,
  loading: () => <TableMapSkeleton />
});

// fallback
const MapJS = dynamic(() => import('./MapJS').then(r => r.MapJS), {
  ssr: false,
  loading: () => <TableMapSkeleton />
});
export function TableMap({
  table,
  dataset
}: TableMapProps) {
  const [maptype, setMaptype] = useState<'none' | 'leaflet' | 'mapbox'>('none');
  const {
    data: geoStats,
    isLoading
  } = useGeoStats(dataset.id, table.id);
  useEffect(() => {
    const hasWebGL2Support = document.createElement('canvas').getContext('webgl2');
    if (hasWebGL2Support) {
      setMaptype('mapbox');
    } else {
      setMaptype('leaflet');
    }
  }, []);
  if (isLoading) {
    return <TableMapSkeleton />;
  }
  return <div className={classes.wrapper}>
      {maptype === 'mapbox' && <MapGL geoStats={geoStats} />}
      {maptype === 'leaflet' && <MapJS geoStats={geoStats} />}
    </div>;
}
export default TableMap;